import formActions from "../utils/common-form-actions";

export default context => {

    $('form.std-ajax', context).on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()
        const form = $(this)
        form.trigger('beforesubmit.coing');
        let formData = new FormData(form[0]);
        formActions.cleanForm(form);
        form.trigger('submitted.coing');
        spinner.show()
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: formData,
            processData: false,
            contentType: false,
        }).then(function(data) {
            spinner.remove()
            if (data.errors) {
                formActions.applyFormErrors(form, data.errors)
            }
            if (data.message) {
                openAlert(data.message, data.success ? 'success' : 'error').then(() => {
                    if (data.redirect) {
                        window.location.href = data.redirect
                    }
                })
            }
            if (data.redirect) {
                window.location.href = data.redirect
            }
        }).catch(xhr => {
            spinner.remove()
            const data = xhr.responseJSON
            if (data.errors) {
                formActions.applyFormErrors(form, data.errors)
            }
            if (data.message) {
                openAlert(data.message, 'error')
            } else if (xhr.responseText) {
                openAlert(xhr.responseText, 'error')
            }
        })

        form.trigger('aftersubm.coing', formData);

    })
}
